var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardTable',{ref:"configTableRef",staticClass:"hc-biz-dc-brief__container dialog-body",staticStyle:{"height":"100%"},attrs:{"page":_vm.page,"initFuc":_vm.initFuc,"get-table-data":_vm.getTableData,"tableConfig":_vm.tableConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }